import React, { useState } from 'react';
import './HomePage.css';

/**
 * HomeProse — a crawlable prose band that stays fully expanded on desktop but
 * collapses behind a "Read more" toggle on phones (Aug 7, Nitish: the long
 * definitional paragraphs read text-heavy on mobile).
 *
 * SEO/AEO-safe by construction: the full text is ALWAYS in the DOM — mobile
 * merely caps the visible height with CSS (max-height + fade mask) until the
 * visitor expands it. Crawlers and answer engines read every word either way;
 * nothing is cloaked or conditionally rendered.
 */
const HomeProse = ({ children }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`home-prose ${expanded ? 'is-expanded' : ''}`}>
      <div className="home-prose__body">{children}</div>
      <button
        type="button"
        className="home-prose__more"
        aria-expanded={expanded}
        onClick={() => setExpanded(true)}
      >
        Read more
      </button>
    </div>
  );
};

export default HomeProse;
